<template>
  <div class="powerList">
    <!-- 光 Solar 风 Wind 储能 Energy Storage 电 Power 氢 Hydrogen -->
    <section class="container">
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-5 g-3">
        <router-link to="/photovoltaic">
          <div class="col">
            <div class="card shadow-sm card-hover">
              <p class="name">{{ $t('homepage.entype.n0') }}</p>
              <div class="card-body">
                <p class="card-text poserItem02"></p>
              </div>
            </div>
          </div>
        </router-link>
        <router-link to="/windpower">
          <div class="col">
            <div class="card shadow-sm card-hover">
              <p class="name">{{ $t('homepage.entype.n1') }}</p>
              <div class="card-body">
                <p class="card-text poserItem01"></p>
              </div>
            </div>
          </div>
        </router-link>
        <router-link to="/store">
          <div class="col">
            <div class="card shadow-sm card-hover">
              <p class="name">{{ $t('homepage.entype.n2') }}</p>
              <div class="card-body">
                <p class="card-text poserItem03"></p>
              </div>
            </div>
          </div>
        </router-link>
        <router-link to="/charging">
          <div class="col">
            <div class="card shadow-sm card-hover">
              <p class="name">{{ $t('homepage.entype.n3') }}</p>
              <div class="card-body">
                <p class="card-text poserItem04"></p>
              </div>
            </div>
          </div>
        </router-link>
        <router-link to="/datacenter">
          <div class="col">
            <div class="card shadow-sm card-hover">
              <p class="name">{{ $t('homepage.entype.n4') }}</p>
              <div class="card-body">
                <p class="card-text poserItem05"></p>
              </div>
            </div></div
        ></router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'powerList',
};
</script>

<style scoped lang="scss">
.poserItem01,
.poserItem02,
.poserItem03,
.poserItem04,
.poserItem05 {
  width: 100%;
  padding-top: 120%; /* 自动高度，等比例 */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.shadow-sm {
  box-shadow: none !important;
}
.poserItem01 {
  background-image: url(~@/assets/images/wcon0.gif);
}
.poserItem02 {
  background-image: url(~@/assets/images/wcon1.gif);
}
.poserItem03 {
  background-image: url(~@/assets/images/wcon2.gif);
}
.poserItem04 {
  background-image: url(~@/assets/images/wcon3.gif);
}
.poserItem05 {
  background-image: url(~@/assets/images/wcon4.gif);
}

.card-body {
  padding: 0;
}
.name {
  color: #908f8d;
  padding: 1rem 0;
  transition: all 0.3s ease;
}
.card {
  border: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
}
.card-text {
  width: 100%;
}

// ========== 鼠标悬浮效果 ==========
.card-hover {
  &:hover {
    transform: translateY(-6px) scale(1.03);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1) !important;

    .name {
      color: #2c7cff; // 主题蓝（可改你们企业色）
      font-weight: 500;
    }

    .card-text {
      transform: scale(1.05);
    }
  }
}
</style>
